import { render, staticRenderFns } from "./FoundingMembers.vue?vue&type=template&id=dcfe7ae0&scoped=true&"
import script from "./FoundingMembers.vue?vue&type=script&lang=js&"
export * from "./FoundingMembers.vue?vue&type=script&lang=js&"
import style0 from "./FoundingMembers.vue?vue&type=style&index=0&id=dcfe7ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfe7ae0",
  null
  
)

export default component.exports